import { Button, Card, Divider } from '@material-ui/core'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Header1 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import { useAppDispatch } from 'src/redux'
import { requestCode } from 'src/redux/slices/Application'

import FileProvider from '../../Files/Context'
import CheckCode from './CheckCode'
import CheckEmail from './CheckEmail'
import { useStyles } from './Style'

interface ConfirmIdentityProps {
  applicationId: string
  setDisplayConfirmIdentity: (value: boolean) => void
  submit: (code: string) => Promise<boolean>
}

const ConfirmIdentity: React.FC<ConfirmIdentityProps> = ({
  applicationId,
  setDisplayConfirmIdentity,
  submit,
}) => {
  const classes = useStyles()
  const i18n = useTranslation()
  const [email, setEmail] = useState<string | null>(null)
  const dispatch = useAppDispatch()

  const submitRequestCode = async (email: string) => {
    if (!applicationId) {
      return
    }
    try {
      const payload = {
        applicationId,
        email,
      }
      dispatch(requestCode(payload))
    } catch (error) {
      throw new Error(`Error requesting code: ${error}`)
    }
  }

  const validateEmail = (inputEmail: string) => {
    setEmail(inputEmail)
    submitRequestCode(inputEmail)
  }

  return (
    <div className={classes.container}>
      <div>
        <Button onClick={() => setDisplayConfirmIdentity(false)}>
          <div className={classes.backButton}>
            <KeyboardBackspaceIcon />
            {i18n.t('back')}
          </div>
        </Button>
        <Card className={classes.card}>
          <Header1>{i18n.t('verify_your_identity')}</Header1>
          {!email ? (
            <FileProvider>
              <CheckEmail validateEmail={validateEmail} />
            </FileProvider>
          ) : (
            <CheckCode submit={submit} requestNewCode={() => submitRequestCode(email)} />
          )}
          <div className={classes.bottomPage}>
            <Divider style={{ width: '100%' }} />
            <div className={classes.bottomPageContent}>
              <img src={FlatsyTheme.image.padlock} alt="padlock" />
              <Body1>{i18n.t('authentication_keep_information_and_documents_confidential')}</Body1>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default ConfirmIdentity
